import api from '../../infrastructure/api/api.service';
import { CATALOG_ACTIONS } from '~/domains/promotion/routes';
import {
  type ActionListResponse,
  type ActionByIdResponse,
} from '~/domains/promotion/types';
import { promotionByIdSerializer, promotionsSerializer } from './serializers';
import { type CategoryRequestQuery } from '~/domains/category';
import categorySerialiser from '~/domains/category/category.serializer.ts';

const promotionRepository = {
  async getActionById(id: string, params: CategoryRequestQuery) {
    const response = await api<ActionByIdResponse>(`${CATALOG_ACTIONS}/${id}`, {
      method: 'GET',
      query: categorySerialiser.categoryBySlugQuery(params),
    });

    return promotionByIdSerializer(response);
  },

  async getActionList() {
    try {
      const response = await api<ActionListResponse>(CATALOG_ACTIONS);
      return promotionsSerializer(response);
    } catch (error) {
      console.error(error);
    }
  },
};

export default promotionRepository;
